import PillarContent from './PillarContent'

export default PillarContent